<template>
  <main-layout :show-elements="!id">
    <title-banner :show-subtitle="page === 1" :image-url="bannerImageUrl" v-if="!id"></title-banner>
    <b-container class="text-left px-5 border-shadow">
      <b-breadcrumb :items="breadcrumbs" v-if="!id"></b-breadcrumb>
      <span class="satmed-Page-info" v-if="page === 6">
        <strong>
          Confirma la información de la alerta
        </strong>
        para que el Sistema de Alertas Tempranas de Medellín (SATMED) pueda orientarte adecuadamente
        respecto a las acciones que debes realizar
      </span>

      <div :class="page === 6 ? 'verify-page' : ''">
        <pagina-nombre-de v-if="page === 1" :page="1" ref="pagina1"></pagina-nombre-de>
        <span class="satmed-Page-info" v-if="page !== 1 && page !== 6">
          <strong>
            Bríndanos la información más completa y precisa, así ayudarás al SATMED para que realice
            las acciones necesarias
          </strong>
          que permitan atender la alerta y orientarte oportunamente.
        </span>

        <div v-if="page === 6" class="satmed-title-container">
          <div class="d-flex">
            <div class="satmed-title" v-if="!id">
              <fai :icon="['far', 'check-circle']" inverse size="2x"></fai>
              Verifica la información de la alerta
            </div>
            <div class="satmed-title" v-if="id">Alerta #{{ id }}</div>
          </div>
        </div>

        <alert-information-form
          :page="page"
          :editar="id"
          ref="pagina2"
          v-show="page === 2 || page === 6"
        ></alert-information-form>

        <pagina-datos-persona
          :page="page"
          :editar="id"
          ref="pagina3"
          v-show="page === 3 || page === 6"
        ></pagina-datos-persona>

        <pagina-informacion-contacto
          :page="page"
          ref="pagina4"
          v-if="a.A_NOM_DE === 1"
          v-show="page === 4 || page === 6"
        ></pagina-informacion-contacto>

        <b-modal
          id="success-modal"
          hide-footer
          hide-header
          size="lg"
          dialog-class="satmed-modal-dialog"
          no-close-on-backdrop
          no-close-on-esc
        >
          <div class="text-center">
            <pagina-success :radicado="radicado"></pagina-success>
            <b-button pill type="button" class="modal-btn satmed-btn-tertiary" @click="resetForm()">
              Aceptar
            </b-button>
          </div>
        </b-modal>

        <b-modal
          id="cancel-modal"
          hide-footer
          hide-header
          size="lg"
          dialog-class="satmed-modal-dialog"
        >
          <div class="text-center">
            <img :src="require('@/assets/images/info-icon.svg')" alt="Icono de información" />
            <h4>Cancelará el envío de la alerta</h4>
            <p>
              La alerta y los datos ingresados no se almacenarán y no podrá hacer el envío de la
              alerta
            </p>
            <h6><strong>¿Está seguro de cancelar el envío de la alerta?</strong></h6>
            <div class="modal-btn-group">
              <b-button
                pill
                type="button"
                class="modal-btn"
                variant="outline-primary"
                @click="resetForm()"
              >
                Sí, cancelar envío
              </b-button>
              <b-button
                pill
                type="button"
                class="modal-btn satmed-btn-primary"
                @click="$bvModal.hide('cancel-modal')"
              >
                Continuar el envío
              </b-button>
            </div>
          </div>
        </b-modal>

        <div v-if="this.id" class="d-flex satmed-dot-tittle justify-content-end align-items-center">
          <div class="ml-5" v-if="page === 3 || page === 6">
            <b-button
              @click="page3.addPersona"
              :disabled="!page3 || !page3.validatePersona()"
              v-if="page3 && page3.showForm"
              pill
              class="satmed-btn-primary"
              size="lg"
            >
              Continuar
            </b-button>
            <b-button
              @click="page3.showForm = true"
              v-if="page3 && !page3.showForm"
              pill
              variant="outline-primary"
              size="lg"
              class="d-block"
            >
              Agregar otra persona
            </b-button>
          </div>
          <div class="ml-5">
            <b-button
              pill
              v-if="page === 6"
              @click="update()"
              :disabled="loading"
              class="satmed-btn-tertiary"
            >
              <b-spinner v-if="loading" small label="Cargando..." style="mr-2"></b-spinner>
              Actualizar alerta
            </b-button>
          </div>
        </div>

        <div v-else-if="page !== 1" class="p-4 alert-form-container-footer">
          <!-- Normal buttons in large devices  -->
          <div class="d-none d-md-flex justify-content-md-end align-items-center">
            <div v-if="page > 1 && page < 6" class="mr-auto m back-button">
              <b-button pill variant="outline-primary" @click="changePage(page - 1)">
                Ir atrás
              </b-button>
            </div>
            <div style="cursor: pointer" @click="openCancelModal()">
              Cancelar
            </div>
            <div class="ml-5" v-if="page === 3 || page === 6">
              <b-button
                @click="page3.addPersona"
                :disabled="!page3 || !page3.validatePersona()"
                v-if="page3 && page3.showForm"
                pill
                class="satmed-btn-primary"
              >
                Continuar
              </b-button>
              <b-button
                @click="page3.showForm = true"
                v-if="page3 && !page3.showForm"
                pill
                variant="outline-primary"
                class="d-block"
              >
                Agregar otra persona
              </b-button>
            </div>
            <div
              class="ml-5"
              v-if="page < 6 && ![1].includes(page) && (page !== 3 || (page3 && !page3.showForm))"
            >
              <b-button
                pill
                @click="next(page)"
                :disabled="!valid(page)"
                class="satmed-btn-primary"
                variant="none"
              >
                Continuar
              </b-button>
            </div>
            <div class="ml-5" v-if="page === 6 && page3 && !page3.showForm">
              <b-button pill @click="send()" :disabled="loading" class="satmed-btn-primary">
                <b-spinner v-if="loading" small label="Cargando..." style="mr-2"></b-spinner>
                Enviar alerta
              </b-button>
            </div>
          </div>

          <!-- Block buttons in small devices with inverted order  -->
          <div class="d-flex d-md-none flex-wrap align-items-center">
            <div class="w-100 mb-3" v-if="page === 3 || page === 6">
              <b-button
                @click="page3.addPersona"
                :disabled="!page3 || !page3.validatePersona()"
                v-if="page3 && page3.showForm"
                pill
                variant="outline-primary"
                size="lg"
                block
              >
                Agregar persona
              </b-button>
              <b-button
                @click="page3.showForm = true"
                v-if="page3 && !page3.showForm"
                pill
                variant="outline-primary"
                size="lg"
                block
              >
                Agregar otra persona
              </b-button>
            </div>
            <div class="w-100 mb-3" v-if="page === 6 && page3 && !page3.showForm">
              <b-button
                pill
                block
                @click="send()"
                :disabled="loading"
                class="satmed-btn-primary"
                size="lg"
              >
                <b-spinner v-if="loading" small label="Cargando..." style="mr-2"></b-spinner>
                Enviar alerta
              </b-button>
            </div>
            <div
              class="w-100 mb-3"
              v-if="page < 6 && ![1].includes(page) && (page !== 3 || (page3 && !page3.showForm))"
            >
              <b-button
                pill
                @click="next(page)"
                :disabled="!valid(page)"
                class="satmed-btn-primary"
                variant="none"
                size="lg"
                block
              >
                Continuar
              </b-button>
            </div>
            <b-button block variant="default" @click="openCancelModal()">
              Cancelar
            </b-button>
          </div>
        </div>
      </div>
    </b-container>
  </main-layout>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

import PaginaNombreDe from '@/components/Alerta/PaginaNombreDe.vue';
import PaginaDatosPersona from '@/components/Alerta/PaginaDatosPersona.vue';
import AlertInformationForm from '@/components/Alerta/AlertInformationForm.vue';
import PaginaInformacionContacto from '@/components/Alerta/PaginaInformacionContacto.vue';
import PaginaSuccess from '@/components/Alerta/PaginaSuccess.vue';
import MainLayout from '@/layouts/MainLayout.vue';
import TitleBanner from '@/layouts/TitleBanner.vue';

export default {
  name: 'NewCase',
  data() {
    return {
      /** @type {string} */
      radicado: null,
      id: null,
      comunaSelected: null,
      barrioSelected: null,
      token: null,
      loading: false,
      baseBreadcrumbs: [
        {
          text: 'Alcaldía de Medellín',
          href: 'https://www.medellin.gov.co/',
        },
        {
          text: 'SATMED',
          href: `.${this.$route.path}`,
        },
      ],
    };
  },
  components: {
    PaginaNombreDe,
    AlertInformationForm,
    PaginaDatosPersona,
    PaginaInformacionContacto,
    PaginaSuccess,
    MainLayout,
    TitleBanner,
  },
  methods: {
    ...mapMutations('alerta', [
      'changePage',
      'setTiposDocumentos',
      'setGeneros',
      'setGenderIdentities',
      'setCountries',
      'setAgeRanges',
      'setOrientacionesSexuales',
      'setNivelesEscolares',
      'setGradosEscolares',
      'setProblematics',
      'setRiskFactors',
      'setBarrios',
      'setComunas',
      'setNumeroHijos',
      'setFuncionarios',
      'setLugaresAlerta',
      'setPageValidate',
      'setFuncionarios',
      'setItem',
    ]),
    async getDataUtils(url, setter, lista) {
      try {
        const { data } = await this.api.get(url);
        data.unshift({
          id: null,
          DESCRIPCION: 'Seleccionar...',
          disabled: true,
        });
        setter(data);
      } catch (err) {
        this.$bvToast.toast(`Ocurrió un error consultando la lista de ${lista}`, {
          title: 'Error',
        });
      }
    },
    async getFuncionarios(url, setter, lista) {
      try {
        const { data } = await this.api.get(url);
        data.unshift({
          id: null,
          NOMBRE: 'Seleccionar...',
          disabled: true,
        });
        setter(data);
      } catch (err) {
        this.$bvToast.toast(`Ocurrió un error consultando la lista de ${lista}`, {
          title: 'Error',
        });
      }
    },
    async getDataComunas() {
      try {
        const { data } = await this.api.get('utils/comunas');
        const datos = [];
        if (data.features) {
          data.features.forEach((e) => {
            datos.push({
              id: e.attributes.COMUNA,
              DESCRIPCION: `Comuna ${e.attributes.COMUNA} - ${e.attributes.NOMBRE}`,
            });
          });
        }
        datos.unshift({
          id: null,
          DESCRIPCION: 'Seleccionar...',
        });
        this.setComunas(datos);
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error consultando la lista de comunas', {
          title: 'Error',
        });
      }
    },
    async getDataBarrios() {
      try {
        const { data } = await this.api.get('utils/barrios');
        const datos = [];
        if (data.features) {
          data.features.forEach((e) => {
            datos.push({
              id: e.attributes.OBJECTID,
              DESCRIPCION: e.attributes.NOMBRE_BARRIO,
              COMUNA: e.attributes.COMUNA,
            });
          });
        }
        datos.unshift({
          id: null,
          DESCRIPCION: 'Seleccionar...',
          COMUNA: null,
        });
        this.setBarrios(datos);
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error consultando la lista de barrios', {
          title: 'Error',
        });
      }
    },
    async getTiposDocumentos() {
      try {
        const { data } = await this.api.get('utils/tipos-documentos');
        const datos = [];
        if (data) {
          data.forEach((e) => {
            datos.push({
              id: e.id,
              DESCRIPCION: e.DESCRIPCION,
              SIGLA: e.SIGLA,
            });
          });
        }
        datos.unshift({
          id: null,
          DESCRIPCION: 'Seleccionar...',
          SIGLA: '--',
        });
        this.setTiposDocumentos(datos);
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error consultando la lista de tipos de documento', {
          title: 'Error',
        });
      }
    },
    async send() {
      try {
        this.loading = true;

        this.fillOtherFields();
        const Form = new FormData();

        Object.keys(this.a).forEach((key) => {
          if (key === 'FILES') {
            this.a[key].forEach((file) => {
              Form.append('FILES', file);
            });
          }
          if (this.a[key] instanceof Array) {
            Form.append(key, JSON.stringify(this.a[key]));
          } else {
            Form.append(key, this.a[key]);
          }
        });

        const { data } = await this.$store.state.api.post('alerta', Form);

        if (data.radicado) {
          window.onbeforeunload = null;
          this.radicado = data.radicado;
          this.$bvModal.show('success-modal');
        }
        this.loading = false;
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error al intentar registrar la alerta', {
          title: '¡Error!',
          variant: 'danger',
        });
        this.loading = false;
      }
    },
    async update() {
      this.loading = true;
      const unmappedRiskFactors = this.a.FACTORES_RIESGO;
      try {
        this.a.FACTORES_RIESGO = this.a.FACTORES_RIESGO.map(
          (riskFactor) => riskFactor.value || riskFactor,
        );
        const { data } = await this.$store.state.api.put('alerta', this.a, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        if (data.radicado) {
          this.$bvToast.toast('La alerta fue actualizada exitosamente', {
            title: '¡Hecho!',
            variant: 'success',
          });
        }
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error al intentar actualizar la alerta', {
          title: '¡Error!',
          variant: 'danger',
        });
      }
      this.a.FACTORES_RIESGO = unmappedRiskFactors;
      this.loading = false;
    },
    valid(page) {
      if (this.$refs[`pagina${page}`]) {
        return this.$refs[`pagina${page}`].validatePage();
      }
      return false;
    },
    next(page) {
      if (!this.valid(page)) {
        this.$bvToast.toast('Verifica todos los campos requeridos', { title: '¡Error!' });
        return;
      }

      this.setPageValidate({ page: this.page, state: true });

      let newPage = page + 1;
      if ((this.a.A_NOM_DE === 0 && newPage === 4) || (this.a.A_NOM_DE === 1 && newPage === 5)) {
        newPage = 6;
      }
      this.changePage(newPage);
    },
    async getAlerta() {
      try {
        const { data } = await this.api.get(`alerta/show-by-id/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        data.PERSONAS_EN_RIESGO = data.Afectados;
        data.FACTORES_RIESGO = data.AlertaFactoresRiesgos.map((alertRiskFactor) => ({
          value: alertRiskFactor.FactoresRiesgo.id,
          text: alertRiskFactor.FactoresRiesgo.DESCRIPCION,
        }));
        data.PUNTO_REFERENCIA = data.Afectados[0].PUNTO_REFERENCIA;
        data.FILES = [];
        data.A_NOM_DE = parseInt(data.A_NOM_DE, 10);
        const [name, surname] = data.NOMBRE_INFO_ALERTA.split(',');
        data.NOMBRE_INFO_ALERTA = name;
        data.APELLIDO_INFO_ALERTA = surname || '';
        this.setItem(data);
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error consultando la alerta a editar', {
          variant: 'danger',
          title: 'Error',
        });
      }
    },
    preventAccidentalLeave() {
      window.history.pushState(null, document.title, window.location.href);
      window.onbeforeunload = () => true;
      window.addEventListener('popstate', () => {
        if (this.page === 1) {
          window.location.replace(process.env.BASE_URL);
          return;
        }
        this.changePage(this.page - 1);
        window.history.pushState(null, document.title, window.location.href);
      });
    },
    resetForm() {
      window.onbeforeunload = null;
      window.scrollTo(0, 0);
      this.$router.go();
    },
    openCancelModal() {
      this.$bvModal.show('cancel-modal');
    },
    fillOtherFields() {
      if (this.a.A_NOM_DE === 0) {
        const informant = this.a.PERSONAS_EN_RIESGO[0];
        this.a.NOMBRE_INFO_ALERTA = `${informant.NOMBRE} ${informant.APELLIDO}`;
        this.a.TIPODOCU_INFO_ALERTA = informant.TIPO_DOCUMENTO_ID;
        this.a.NDOCU_INFO_ALERTA = informant.DOCUMENTO;
        this.a.GENERO_INFO_ALERTA = informant.GENERO_ID;
        this.a.NCONTACTO_INFORMA = informant.TELEFONO;
      } else if (this.a.APELLIDO_INFO_ALERTA) {
        this.a.NOMBRE_INFO_ALERTA += `, ${this.a.APELLIDO_INFO_ALERTA}`;
      }

      for (let i = 0; i < this.a.PERSONAS_EN_RIESGO.length; i += 1) {
        const affectedPerson = this.a.PERSONAS_EN_RIESGO[i];
        affectedPerson.COMUNA_ID = this.a.COMUNA_ID;
        affectedPerson.BARRIO_ID = this.a.BARRIO_ID;
        affectedPerson.DIRECCION = affectedPerson.DIRECCION || this.a.DIRECCION_ALERTA;
        affectedPerson.PUNTO_REFERENCIA = this.a.PUNTO_REFERENCIA;
      }
    },
  },
  computed: {
    ...mapState({
      page: (state) => state.alerta.page,
      a: (state) => state.alerta.item,
      api: (state) => state.api,
      pageValidate: (state) => state.alerta.pageValidate,
    }),
    /** @returns {{text:string, href?:string}[]} */
    breadcrumbs() {
      if (this.page === 1) {
        return this.baseBreadcrumbs;
      }

      return [
        ...this.baseBreadcrumbs,
        {
          text: 'Nuevo caso',
        },
      ];
    },
    /** @returns {string} */
    bannerImageUrl() {
      // eslint-disable-next-line global-require
      return require('@/assets/images/banner-formulario.jpg');
    },
    ...mapGetters('alerta', ['getTextById']),
    /** @returns {{showForm: boolean, validatePersona: () => boolean, addPersona: () => void  }} */
    page3() {
      return this.$refs.pagina3;
    },
  },
  mounted() {
    this.preventAccidentalLeave();
    this.getDataUtils('utils/generos', this.setGeneros, 'generos');
    this.getDataUtils(
      'utils/identidades-genero',
      this.setGenderIdentities,
      'identidades de Genero',
    );
    this.getDataUtils(
      'utils/orientaciones-sexuales',
      this.setOrientacionesSexuales,
      'orientaciones sexuales',
    );
    this.getDataUtils('utils/niveles-escolares', this.setNivelesEscolares, 'niveles escolares');
    this.getDataUtils('utils/grados-escolares', this.setGradosEscolares, 'grados escolares');
    this.getDataUtils('utils/problematicas', this.setProblematics, 'problemáticas');
    this.getDataUtils('utils/countries', this.setCountries, 'paises');
    this.getDataUtils('utils/age-ranges', this.setAgeRanges, 'rangos de edad');
    this.getDataUtils('utils/factores-riesgos', this.setRiskFactors, 'factores de riesgo');
    this.getDataUtils('utils/numero-hijos', this.setNumeroHijos, 'número de hijos');
    this.getFuncionarios('utils/funcionarios', this.setFuncionarios, 'Funcionarios');
    this.getDataComunas();
    this.getDataBarrios();
    this.getTiposDocumentos();
    this.setLugaresAlerta([
      { id: null, DESCRIPCION: 'Seleccione', disabled: true },
      { id: 1, DESCRIPCION: 'Hogar' },
      { id: 2, DESCRIPCION: 'Entorno educativo' },
      { id: 3, DESCRIPCION: 'Sitios comunes' },
      { id: 4, DESCRIPCION: 'Otra residencia, familiar o conocida' },
      { id: 5, DESCRIPCION: 'Otro' },
    ]);
  },
  created() {
    // Traemos los datos de la operación a editar
    this.id = this.$route.params.id;
    if (this.id) {
      this.token = this.$route.params.token;
      this.changePage(6);
      this.getAlerta();
    }
  },
  watch: {
    a: {
      deep: true,
      handler() {
        this.comunaSelected = this.a.COMUNA_ID;
        this.barrioSelected = this.a.BARRIO_ID;
        if (this.a.id) {
          this.a.POLITICA = true;
        }
      },
    },
    comunaSelected() {
      this.a.COMUNA_ID = this.comunaSelected;
      this.a.COMUNA_NAME = this.getTextById(this.comunaSelected, 'comunas', 'text');
      if (!this.a.id) {
        this.barrioSelected = null;
        this.a.BARRIO_ID = null;
        this.a.BARRIO_NAME = this.getTextById(this.barrioSelected, 'barrios', 'text');
      }
    },
    barrioSelected() {
      this.a.BARRIO_ID = this.barrioSelected;
      this.a.BARRIO_NAME = this.getTextById(this.barrioSelected, 'barrios', 'text');
    },
  },
};
</script>

<style lang="scss">
.satmed-social-media {
  font-size: 2.7rem;
  cursor: pointer;
  transition: 0.5s ease;
}
.satmed-social-media:hover {
  color: #009ee3;
}
.back-button {
  color: #bc86d0;
}

div:not(.verify-page) {
  & > * > .alert-form-container {
    position: relative;
    padding: 30px 30px 0 30px;
    margin: 30px -30px 0px -30px;
    border-radius: 10px 10px 0 0;
    background-color: white;
    &::after {
      border-radius: 10px 10px 0 0;
    }
  }

  & > .alert-form-container-footer {
    position: relative;
    border-radius: 0 0 10px 10px;
    margin: 0px -30px;
    border-top: 1px solid #dfdede;
    background-color: white;
    &::after {
      border-radius: 0 0 10px 10px;
    }
  }

  & > * > .alert-form-container::after,
  & > .alert-form-container-footer::after {
    position: absolute;
    content: '';
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: 0px 10px 30px -3px #6060606b;
    z-index: -1;
  }
}

.verify-page {
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 10px 30px -3px #6060606b;
  margin: 24px -20px;
  border-radius: 25px 25px 10px 10px;
  overflow: hidden;

  .satmed-dot-tittle {
    margin-top: 10px;
  }

  & > *:not(:last-child) {
    padding: 20px 25px;
  }
}

.d-flex .h3.m-0 {
  font-size: 18px;
}

.form-control,
custom-select {
  font-size: 14px;
}

.container.text-left.px-5.border-shadow {
  max-width: 1680px;
  @media screen and (max-width: 992px) {
    padding: 13px 30px !important;
  }
}

.satmed-modal-dialog {
  border-radius: 20px;
  overflow: hidden;
  .modal-btn {
    margin-top: 15px;
    margin-right: 20px;
    height: 39px;
    &:last-child {
      margin-right: 0px;
    }
  }
  &.modal-lg {
    max-width: 597px;
  }
}
</style>

<style lang="scss" scoped>
.satmed-Page-info {
  font: normal normal normal 18px/30px Montserrat;
  letter-spacing: -0.18px;
}

.satmed-modal-dialog {
  h4,
  h6 {
    margin-top: 47px;
  }
  h6 {
    margin-bottom: 47px;
  }
  p {
    margin-top: 17px;
  }
}

.breadcrumb {
  background: none;
  padding: 0;
  border: none;
}
</style>
